import { createStyles, makeStyles } from "@material-ui/core";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutline";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ColumnModel, PageInfoModel } from "../../../models/common.model";
import {
  getTablePage,
  getTableSelectedRow,
} from "../../../redux/table/tableSlice";
import { MAINCATEGORYID } from "../../../config/cacheKey";

const nextIcon = () => {
  return (
    <img
      style={{ height: "12px", width: "10px" }}
      src="images/Next.png"
      alt=""
    />
  );
};
const previusIcon = () => {
  return (
    <img
      style={{ height: "12px", width: "10px" }}
      src="images/Previous.png"
      alt=""
    />
  );
};
const useStyles = makeStyles(() =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: "#CEE5D3 !important",
      },
    },
  })
);
const columns: readonly ColumnModel[] = [
  { id: "title", label: "عنوان گروه کالا" },
  { id: "englishTitle", label: "عنوان انگلیسی" },
  { id: "hexCode", label: "کدرنگ" },
  { id: "sortIndex", label: "ترتیب نمایش" },
  { id: "isActivePersian", label: "وضعیت گروه کالا" },
];
interface Props {
  productCategoryList: any[];
  pageInfo: PageInfoModel;
  setCurrentPaginationInfo: (page: any) => void;
  currentPaginationInfo: any;
  handelDelete: Function;
  handleRouteToProductDetail: Function;
}
const ProductCategoryTable = ({
  currentPaginationInfo,
  pageInfo,
  productCategoryList,
  setCurrentPaginationInfo,
  handelDelete,
  handleRouteToProductDetail,
}: Props) => {
  const classes = useStyles();
  const history = useHistory<any>();

  const dispatch = useDispatch();
  const tableInfo = useSelector((state: any) => state.table);

  const changePageNumber = (newPageNumber: number) => {
    setCurrentPaginationInfo({
      pageNumber: newPageNumber,
      pageSize: 10,
    });
  };
  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    dispatch(
      getTableSelectedRow({
        selectedRowNum: 0,
      })
    );
    dispatch(
      getTablePage({
        selectedPageNum: value,
      })
    );
  };
  useEffect(() => {
    if (history.action === "POP") {
      setCurrentPaginationInfo({
        pageNumber: tableInfo.selectedPageNum,
        pageSize: 10,
      });
    }
  }, [history.action, setCurrentPaginationInfo, tableInfo.selectedPageNum]);
  const handelDetail = (id: number) => {
    history.push({
      pathname: "/store/ProductSubgroupTable",
    });
    localStorage.setItem(MAINCATEGORYID, id.toString());
  };
  return (
    <div>
      <div>
        <div className="cardTableBorder">
          <TableContainer
            style={{ background: "#fff", maxHeight: "55vh" }}
            className="boxScroll"
          >
            <Table
              stickyHeader
              aria-label="sticky table"
              style={{ borderCollapse: "collapse" }}
            >
              <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
                <TableRow
                  classes={{ root: classes.select }}
                  className={`${classes} borderRight borderLeft`}
                  selected={tableInfo.selectedRowNum}
                >
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight WidthRowNumber"
                    align="right"
                    style={{ width: "10vh", minWidth: "10vh" }}
                  >
                    ردیف
                  </TableCell>

                  {columns.map((column) => (
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight noWrap"
                      key={column.id}
                      align="right"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight noWrap"
                    sx={{ textAlign: "end !important", width: "5vh" }}
                  >
                    <MoreHorizIcon
                      scale="scale(1.8) "
                      style={{ color: "#1D4A87" }}
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
              <div style={{ width: "100%", height: "10px" }}></div>
              <TableBody>
                {productCategoryList.length > 0
                  ? productCategoryList?.map((row, rowIndex) => {
                      return (
                        <TableRow
                          classes={{ root: classes.select }}
                          className={`${
                            rowIndex % 2 === 0 ? "rowTBodyE  " : "rowTBodyO "
                          } ${classes} borderRight borderLeft cursorPointer noWrap`}
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                          selected={tableInfo.selectedRowNum === rowIndex}
                        >
                          <TableCell
                            className="textFont12 WidthRowNumber"
                            style={{ width: "10vh", minWidth: "10vh" }}
                          >
                            {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                              (currentPaginationInfo.pageSize! ?? 0) +
                              rowIndex +
                              1}
                          </TableCell>
                          {columns.map((column) => {
                            const value = row[column.id as keyof any];
                            return (
                              <>
                                {column.id === "isActivePersian" ? (
                                  <TableCell
                                    onClick={() => handelDetail(row.id)}
                                    className="textFont12"
                                    key={column.id}
                                    align="right"
                                  >
                                    {value === "فعال" ? (
                                      <span style={{ color: "#28A745" }}>
                                        فعال
                                      </span>
                                    ) : (
                                      <span style={{ color: "#E6123D" }}>
                                        غیر فعال
                                      </span>
                                    )}
                                  </TableCell>
                                ) : (
                                  <TableCell
                                    onClick={() => handelDetail(row.id)}
                                    className="textFont12"
                                    key={column.id}
                                    align="right"
                                  >
                                    {!value ? (
                                      <>--</>
                                    ) : column.format && column.hasFormat ? (
                                      column.format(value)
                                    ) : (
                                      value?.toString()
                                    )}
                                  </TableCell>
                                )}
                              </>
                            );
                          })}
                          <TableCell
                            className="textFont12"
                            sx={{ textAlign: "end !important" }}
                          >
                            <EditOutlinedIcon
                              sx={{
                                color: "#1D4A87",
                                fontSize: "1.8rem",
                                cursor: "pointer",
                                marginInline: "8px",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                dispatch(
                                  getTableSelectedRow({
                                    selectedRowNum: rowIndex,
                                  })
                                );
                                handleRouteToProductDetail(row.id);
                              }}
                            />
                            <DeleteOutlineOutlinedIcon
                              onClick={() => handelDelete(row.id)}
                              style={{
                                color: "#1D4A87",
                                cursor: "pointer",
                                marginInline: "3px",
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div>
          <Grid container spacing={2} alignItems="center">
            <Grid
              item
              xs={12}
              sm={4}
              display="flex"
              justifyContent={{ xs: "center", sm: "flex-start" }}
            >
              <span
                style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
              >
                تعداد کل :
                <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
              </span>
            </Grid>
            <Grid item xs={12} sm={4} display="flex" justifyContent="center">
              <Pagination
                renderItem={(item) => (
                  <PaginationItem
                    components={{
                      previous: previusIcon,
                      next: nextIcon,
                    }}
                    {...item}
                  />
                )}
                sx={{
                  direction: "ltr",
                  margin: "5px",
                  button: {
                    color: "#25D1C9",
                    fontSize: "14px !important",
                    fontFamily: "iranSans",
                  },
                }}
                count={
                  pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
                }
                onChange={handleChangePagination}
                page={currentPaginationInfo.pageNumber}
              />
            </Grid>
            <Grid item xs={12} sm={4}></Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default ProductCategoryTable;
